import { gql } from "@apollo/client"

export const GET_LOCATIONS_BY_ENTERPRISE = gql`
  query Locations($staff_id: ID!, $enterprise_id: ID!) {
    locations: getLocationsListByEnterpriseId(
      staff_id: $staff_id
      enterprise_id: $enterprise_id
    ) {
      location_id
      location_name
      organizations
      location_status
      location_id_creator
      location_id_enterprise_managed
    }
  }
`

export const GET_LOCATIONS_BY_CTX = gql`
  query Locations($staff_id: ID!, $organization_id: ID!) {
    locations: getLocationsByOrganization(
      staff_id: $staff_id
      organization_id: $organization_id
    ) {
      location_id
      location_name
      organization_id
      organization_name
      location_status
      location_create_date
      location_change_date
      location_id_creator
      location_id_enterprise_managed
    }
  }
`
export const CHANGE_STATUS_LOCATION = gql`
  mutation ChangeStatusLocation(
    $staff_id: String!
    $staff_alias: String!
    $location_id: String!
    $location_status: String!
  ) {
    changeLocationStatus(
      staff_id: $staff_id
      staff_alias: $staff_alias
      location_id: $location_id
      location_status: $location_status
    ) {
      location_id
    }
  }
`
export const GET_ORGANIZATIONS = gql`
  query Organizations($staff_id: ID!, $organization_id: ID!) {
    organizations: statsOrganizationsByUid(
      staff_id: $staff_id
      organization_id: $organization_id
    ) {
      organization_id
      organization_name
      organization_status
      current_staff_users
      current_participants
      current_programs
      current_locations
      organization_id_stamp
    }
  }
`
